import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Plant } from 'src/app/models/plant.model';
import { AppConfigService } from 'src/app/_service/appconfigservice';

@Injectable({
  providedIn: 'root',
})
export class PlantsService {

  gnBaseURL: any;
  // For Plant List
  private plantSubject = new BehaviorSubject<any[]>([]);
  plants$ = this.plantSubject.asObservable();
  setPlants(plants: any[]) {
    this.plantSubject.next(plants);
  }

  // For Selected Plant 
  private selectedPlantSubject = new BehaviorSubject<number | null>(null);
  selectedPlant$ = this.selectedPlantSubject.asObservable();

  setSelectedPlant(id: number) {
    //     console.log("SET PLANT =>", id);
    // console.trace();
    this.selectedPlantSubject.next(id);
  }
  // For Selected Train 
  private selectedTrainSubject = new BehaviorSubject<number | null>(null);
  selectedTrain$ = this.selectedTrainSubject.asObservable();

  setSelectedTrain(trainId: number) {
    //     console.log("SET TRAIN =>", trainId);
    // console.trace();
    this.selectedTrainSubject.next(trainId);
  }

  // for plant validation
  private plantValidationSubject = new BehaviorSubject<boolean>(false);
  plantValidation$ = this.plantValidationSubject.asObservable();

  setPlantValidation(value: boolean) {
    this.plantValidationSubject.next(value);
  }
  
  //  // For calcOpdataList 
  //private calcOpdataListSubject = new BehaviorSubject<any[]>([]);
  //calcOpdataList$ = this.calcOpdataListSubject.asObservable();
  //setCalcOpdataList(opdataList: any[]) {
  //  this.calcOpdataListSubject.next(opdataList);
  //}

  constructor(private http: HttpClient, private appURL: AppConfigService) {
    this.gnBaseURL = this.appURL.getServerUrl();
  }

  getAllPlant(): Observable<Plant[]> {
    return this.http.get<Plant[]>(this.gnBaseURL + 'Plant/GetPlantList');
  }
  getPlantsByUserId(id: string):Observable<Plant[]>
{
  return this.http.get<Plant[]>(this.gnBaseURL +'Plant/GetPlantByUserId/' + id);
  }
  addPlant(addPlantRequest, files) {
    var formData = new FormData();
    formData.append('AddPlantInfo', JSON.stringify(addPlantRequest));
    console.log(formData);
    if (files != null) {
      for (var i = 0; i < files.length; i++) {
        formData.append(files[i].name, files[i]);
      }
    }
    return this.http.post<any>(this.gnBaseURL + 'Plant/AddPlant', formData);
  }

  getAttachment(id: number): Observable<Blob> {
    return this.http.get(`${this.gnBaseURL}Plant/GetThumbnailImg/${id}`, { responseType: 'blob' });
  }

  getAttachment2(id: number) {
    return this.http.get(this.gnBaseURL + "Plant/GetThumbnailImg2/" + id, { responseType: 'blob' }).
      pipe();
  }

  getPlant(id: string): Observable<Plant> {
    return this.http.get<Plant>(this.gnBaseURL + 'Plant/GetPlantById/' + id);
  }

  updatePlant(updatePlantRequest, files): Observable<Plant> {
    var formData = new FormData();
    formData.append('EditPlantInfo', JSON.stringify(updatePlantRequest));
    console.log(formData);
    if (files != null) {
      for (var i = 0; i < files.length; i++) {
        formData.append(files[i].name, files[i]);
      }
    }
    return this.http.post<Plant>(this.gnBaseURL + 'Plant/EditPlant', formData);
  }


  deletePlant(Id: number) {
    return this.http.get(
      this.gnBaseURL + 'Plant/'+ Id +'/action/delete' 
    );
  }
}
